import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/client/lib/utils';
import type { HTMLAttributes } from 'react';

const alertVariants = cva(
  [
    'relative rounded-lg p-4 font-sans text-body-small',
    'backdrop-blur-md border',
    'shadow-glass-soft',
  ].join(' '),
  {
    variants: {
      variant: {
        info: 'border-primary/20 bg-primary-50/80 text-primary-dark',
        error: 'border-error/30 bg-red-50/80 text-error',
        success: 'border-success/30 bg-green-50/80 text-success',
        warning: 'border-warning/30 bg-yellow-50/80 text-[#7a5500]',
      },
    },
    defaultVariants: { variant: 'info' },
  },
);

type AlertProps = HTMLAttributes<HTMLDivElement> & VariantProps<typeof alertVariants>;

export function Alert({ className, variant, role = 'status', ...props }: AlertProps) {
  return <div role={role} className={cn(alertVariants({ variant }), className)} {...props} />;
}
